
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as createZRhptw1mu5_Uao7w1wNoS_5t3tbfFh1xZlHGLWv4q_8Meta } from "/app/app/pages/edi/ack/create.vue?macro=true";
import { default as poCKGcU2zRRU4dBvqt8aIMuKrJlROLJPSDtAKj6_L09zcMeta } from "/app/app/pages/edi/ack/po.vue?macro=true";
import { default as createy67awDgrFSu3JHax22s9MxlAi2ZtxCzzd__2nKvz4GoMeta } from "/app/app/pages/edi/asn/create.vue?macro=true";
import { default as po59La_9_id3R28Fd9cWrhjjtmAJ3wMa2OALTZeMwbLaYMeta } from "/app/app/pages/edi/asn/po.vue?macro=true";
import { default as createcmZjVIKzUNMm4UsBR6YWmgsIhnJOrDy5h_P4XGPkMpoMeta } from "/app/app/pages/edi/inv/create.vue?macro=true";
import { default as invoiceW8wbY4bCyeru7eaT3w3944KPIo59Tyj4PtxwS_piLVAMeta } from "/app/app/pages/edi/inv/invoice.vue?macro=true";
import { default as reviewxeo8i1faJK4C5_iLeEa2VXhTPDmHc7ZgW12AgZn0cMcMeta } from "/app/app/pages/edi/inv/review.vue?macro=true";
import { default as createiZODCZmEHHVKZBZTtn34NCIUwfOAUC4Ak4zaynzbir8Meta } from "/app/app/pages/edi/pochg/create.vue?macro=true";
import { default as reviewSoUouXWw3hk1gA9LwqJOujP9DsZL7r_EMip_PzcAdT4Meta } from "/app/app/pages/edi/pochg/review.vue?macro=true";
import { default as po_kG2tVlm5DKXZ5gbcS8xPJvzwVwiY4NSO8OH3Fg6lH4Meta } from "/app/app/pages/edi/pomodel/po.vue?macro=true";
import { default as loginKijtvhrcYpb5YoezFRgMHggVoPd3Q738tlQZOIojJ2EMeta } from "/app/app/pages/auth/login.vue?macro=true";
import { default as logoutKrpdl4gJJBsd6sAEr9vWISm6ynUi3tHOWZ430uowAsQMeta } from "/app/app/pages/auth/logout.vue?macro=true";
import { default as unauthorizedAy_UaOUWcnva2q2Pxv9HGshbSriUeCA86c6uWAMeetYMeta } from "/app/app/pages/auth/unauthorized.vue?macro=true";
import { default as guardjC7soD20To1_JqaYXirq8NhGqkmOVBLg39LAphqTtCMMeta } from "/app/app/pages/edi/guard.vue?macro=true";
import { default as poHbfOxrofYFPddoXZfCOLNUvEcVHYkXlghl5rKjaRsh0Meta } from "/app/app/pages/edi/po.vue?macro=true";
import { default as dashboard_wBkj5mcWcNBYmGaqbnwialcYbqM22RBBskWoJ_Ux6cMeta } from "/app/app/pages/inventory/dashboard.vue?macro=true";
import { default as uploadFIrXuPqT_H_8OZ2F6ob2GgLCxCTTY60b_l3dgk3Ii6MMeta } from "/app/app/pages/inventory/upload.vue?macro=true";
import { default as _91_46_46_46all_93hFz3McfsdJMQmJ_HL50tY0kFcbUYXu7e_6yVZ9m9Kv8Meta } from "/app/app/pages/[...all].vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "edi-ack-create",
    path: "/edi/ack/create",
    meta: { ...(createZRhptw1mu5_Uao7w1wNoS_5t3tbfFh1xZlHGLWv4q_8Meta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/ack/create.vue")
  },
  {
    name: "edi-ack-po",
    path: "/edi/ack/po",
    meta: { ...(poCKGcU2zRRU4dBvqt8aIMuKrJlROLJPSDtAKj6_L09zcMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/ack/po.vue")
  },
  {
    name: "edi-asn-create",
    path: "/edi/asn/create",
    meta: { ...(createy67awDgrFSu3JHax22s9MxlAi2ZtxCzzd__2nKvz4GoMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/asn/create.vue")
  },
  {
    name: "edi-asn-po",
    path: "/edi/asn/po",
    meta: { ...(po59La_9_id3R28Fd9cWrhjjtmAJ3wMa2OALTZeMwbLaYMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/asn/po.vue")
  },
  {
    name: "edi-inv-create",
    path: "/edi/inv/create",
    meta: { ...(createcmZjVIKzUNMm4UsBR6YWmgsIhnJOrDy5h_P4XGPkMpoMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/inv/create.vue")
  },
  {
    name: "edi-inv-invoice",
    path: "/edi/inv/invoice",
    meta: { ...(invoiceW8wbY4bCyeru7eaT3w3944KPIo59Tyj4PtxwS_piLVAMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/inv/invoice.vue")
  },
  {
    name: "edi-inv-review",
    path: "/edi/inv/review",
    meta: { ...(reviewxeo8i1faJK4C5_iLeEa2VXhTPDmHc7ZgW12AgZn0cMcMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/inv/review.vue")
  },
  {
    name: "edi-pochg-create",
    path: "/edi/pochg/create",
    meta: { ...(createiZODCZmEHHVKZBZTtn34NCIUwfOAUC4Ak4zaynzbir8Meta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/pochg/create.vue")
  },
  {
    name: "edi-pochg-review",
    path: "/edi/pochg/review",
    meta: { ...(reviewSoUouXWw3hk1gA9LwqJOujP9DsZL7r_EMip_PzcAdT4Meta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/pochg/review.vue")
  },
  {
    name: "edi-pomodel-po",
    path: "/edi/pomodel/po",
    meta: { ...(po_kG2tVlm5DKXZ5gbcS8xPJvzwVwiY4NSO8OH3Fg6lH4Meta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/pomodel/po.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginKijtvhrcYpb5YoezFRgMHggVoPd3Q738tlQZOIojJ2EMeta || {},
    component: () => import("/app/app/pages/auth/login.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: logoutKrpdl4gJJBsd6sAEr9vWISm6ynUi3tHOWZ430uowAsQMeta || {},
    component: () => import("/app/app/pages/auth/logout.vue")
  },
  {
    name: "auth-unauthorized",
    path: "/auth/unauthorized",
    meta: unauthorizedAy_UaOUWcnva2q2Pxv9HGshbSriUeCA86c6uWAMeetYMeta || {},
    component: () => import("/app/app/pages/auth/unauthorized.vue")
  },
  {
    name: "edi-guard",
    path: "/edi/guard",
    meta: { ...(guardjC7soD20To1_JqaYXirq8NhGqkmOVBLg39LAphqTtCMMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/guard.vue")
  },
  {
    name: "edi-po",
    path: "/edi/po",
    meta: { ...(poHbfOxrofYFPddoXZfCOLNUvEcVHYkXlghl5rKjaRsh0Meta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/edi/po.vue")
  },
  {
    name: "inventory-dashboard",
    path: "/inventory/dashboard",
    meta: { ...(dashboard_wBkj5mcWcNBYmGaqbnwialcYbqM22RBBskWoJ_Ux6cMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/inventory/dashboard.vue")
  },
  {
    name: "inventory-upload",
    path: "/inventory/upload",
    meta: { ...(uploadFIrXuPqT_H_8OZ2F6ob2GgLCxCTTY60b_l3dgk3Ii6MMeta || {}), ...{"middleware":["sidebase-auth","workspace-access"]} },
    component: () => import("/app/app/pages/inventory/upload.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    meta: _91_46_46_46all_93hFz3McfsdJMQmJ_HL50tY0kFcbUYXu7e_6yVZ9m9Kv8Meta || {},
    component: () => import("/app/app/pages/[...all].vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {}), ...{"middleware":"sidebase-auth"} },
    component: () => import("/app/app/pages/index.vue")
  }
]